import React, { Component } from 'react';

/**
 *   Reference: http://jsfiddle.net/jhudson8/dahdx6eu/
 */

export default class Table extends Component {

	state = {
        data : [],
        headers : []
    }

	componentDidMount() {

	}

    componentWillReceiveProps(nextProps) {
    	this.setState({
    		data : nextProps.data,
    		headers : nextProps.headers,
    	},() => {});
    }

    shouldComponentUpdate(nextProps, nextState) {
    	return true;
    }

    generateHeaders() {
    	var headers = this.state.headers;

    	var heads = headers.map((header) => {
    		return <th key={header.key}>{header.label}</th>;
    	})

		return <tr key='0'>{heads}</tr>;
    }

    generateRows() {
    	var headers = this.state.headers;
    	var rows = this.state.data;

		if(rows) {
			return rows.map((row) => {
				var cells = headers.map((data, i) => {
					var styles = {
						verticalAlign: 'middle',
					}
					if(data.key === 'amount_paid' || data.key === 'balance') {
						styles.textAlign = 'right';
					}
					return <td key={i} data-id={row.id} style={styles}>{row[data.key]}</td>;
				});
				return <tr key={row.id} onClick={this.handleRowClick} style={{cursor:'pointer'}} >{cells}</tr>;
			});
		}

    }

	handleRowClick = (e) => {
		if(this.props.rowClick) {
			this.props.rowClick(e);
		}
	}

	render() {
        var headerComponents = this.generateHeaders(),
            rowComponents = this.generateRows();
		return (
			<table className="table table-striped table-hover globalTable" id={this.props.id}>
				<thead>
					{ headerComponents }
				</thead>
				<tbody>
					{ rowComponents }
				</tbody>
			</table>
		)
	}
}



/** WEBPACK FOOTER **
 ** ./src/commons/Table/Table.js
 **/